import { BehaviorSubject, combineLatest, map, Subject } from "rxjs";
import { computed } from "../../../decorators/computed";

export class Sku$ {
  public sku$: Subject<string> = new BehaviorSubject("");
  public name$: Subject<string> = new BehaviorSubject("");
  public description$: Subject<string> = new BehaviorSubject("");
  public category$: Subject<string> = new BehaviorSubject("");
  public material$: Subject<string> = new BehaviorSubject("");
  public asin$: Subject<string> = new BehaviorSubject("");
  public hs$: Subject<string> = new BehaviorSubject("");
  public hts$: Subject<string> = new BehaviorSubject("");
  public upc$: Subject<string> = new BehaviorSubject("");

  @computed
  get sku$error$() {
    return this.sku$.pipe(
      map((sku) => {
        if (sku === null || sku.length === 0) {
          return "SKU is required.";
        }
        return null;
      })
    );
  }

  @computed
  get json$() {
    return combineLatest({
      sku: this.sku$,
      name: this.name$,
      description: this.description$,
      category: this.category$,
      material: this.material$,
      asin: this.asin$,
      hs: this.hs$,
      hts: this.hts$,
      upc: this.upc$,
    });
  }
}
